"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/BannerAlert.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);















const BannerAlert = ({
  message = "",
  icon = "notification_important",
  actions,
  onClick,
  breathing,
  warning,
}) => {
  // Buttons stop propagation so a whole-banner onClick never double-fires
  // when the user hits the explicit action.
  const buttons = actions.map((a, i) => (
    _react2.default.createElement('button', {
      key: i,
      className: "banner-alert--button",
      onClick: e => { e.stopPropagation(); a.func() }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}}

      , a.text
    )
  ))

  const className = "banner-alert " +
                    (breathing ? "breathing " : "") +
                    (warning ? "warning " : "") +
                    (onClick ? "clickable " : "")

  // With onClick the whole banner is one large click target (role/tabIndex
  // make it keyboard-reachable); without it, behavior is unchanged.
  const interactiveProps = onClick
    ? {
        onClick,
        role: 'button',
        tabIndex: 0,
        onKeyDown: e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            onClick()
          }
        },
      }
    : {}

  return (
    _react2.default.createElement('div', { className: className, ...interactiveProps, __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
      , _react2.default.createElement('div', { className: "banner-alert-left", __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
        , _react2.default.createElement('i', { className: "material-icons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}, icon)
        , message
      )
      , _react2.default.createElement('div', { className: "banner-alert--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}
        , buttons
      )
    )
  )
}

exports. default = BannerAlert
